import { abstractField } from 'vue-form-generator';

//

var script = {
  mixins: [ abstractField ],
  computed: {
    choices: function choices () {
      var ref = this.schema;
      var values = ref.values;
      return this.getSchemaValue(values)
    },

    questions: function questions () {
      var ref = this.schema;
      var questions = ref.questions;
      return this.getSchemaValue(questions)
    },

    wrapperClass: function wrapperClass () {
      var ref = this.schema;
      var wrapperClass = ref.wrapperClass;
      return wrapperClass || 'table-responsive'
    },

    tableClass: function tableClass () {
      var ref = this.schema;
      var tableClass = ref.tableClass;
      return tableClass || 'table table-bordered'
    }
  },
  methods: {
    getSchemaValue: function getSchemaValue (values) {
      if (typeof values === 'function') {
        return values.apply(this, [this.model, this.schema])
      } else {
        return values
      }
    },

    handleChange: function handleChange (question, choice, event) {
      var obj;

      this.value = Object.assign({}, this.value, ( obj = {}, obj[question.id] = choice.value, obj ));
    }
  }
};

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.wrapperClass }, [
    _c("table", { class: _vm.tableClass }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c("th", { attrs: { scope: "col" } }),
            _vm._v(" "),
            _vm._l(_vm.choices, function(choice) {
              return _c("th", { key: choice.value, attrs: { scope: "col" } }, [
                _vm._v("\n          " + _vm._s(choice.name) + "\n        ")
              ])
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.questions, function(question) {
          return _c(
            "tr",
            { key: question.name },
            [
              _c("th", { attrs: { scope: "row" } }, [
                _c(
                  "div",
                  { class: ["form-group", question.required && "required"] },
                  [_c("label", [_vm._v(_vm._s(question.name))])]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.choices, function(choice) {
                return _c(
                  "td",
                  {
                    key: choice.value,
                    staticClass: "touch-sensitive text-center"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "attributes",
                          rawName: "v-attributes",
                          value: "input",
                          expression: "'input'"
                        }
                      ],
                      class: _vm.schema.fieldClasses,
                      attrs: { type: "radio", name: question.id },
                      domProps: {
                        value: choice.value,
                        checked:
                          _vm.value && _vm.value[question.id] === choice.value
                      },
                      on: {
                        click: function($event) {
                          _vm.handleChange(question, choice, $event);
                        }
                      }
                    })
                  ]
                )
              })
            ],
            2
          )
        })
      )
    ])
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-5be9da04_0", { source: "\n.touch-sensitive {\n  position: relative;\n}\n.touch-sensitive:hover {\n    background-color: #eee;\n}\n.touch-sensitive input:after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    pointer-events: auto;\n    content: \"\";\n    background-color: rgba(0, 0, 0, 0);\n}\n\n/*# sourceMappingURL=Matrix.vue.map */", map: {"version":3,"sources":["/Users/shwld/projects/shwld/vfg-field-matrix/src/components/Matrix.vue","Matrix.vue"],"names":[],"mappings":";AA8EA;EACA,mBAAA;CAYA;AAbA;IAGA,uBAAA;CAAA;AAHA;IAKA,mBAAA;IACA,OAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;IACA,qBAAA;IACA,YAAA;IACA,mCAAA;CAAA;;AC5EA,sCAAsC","file":"Matrix.vue","sourcesContent":[null,".touch-sensitive {\n  position: relative; }\n  .touch-sensitive:hover {\n    background-color: #eee; }\n  .touch-sensitive input:after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    pointer-events: auto;\n    content: \"\";\n    background-color: rgba(0, 0, 0, 0); }\n\n/*# sourceMappingURL=Matrix.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* component normalizer */
  function __vue_normalize__(
    template, style, script$$1,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "/Users/shwld/projects/shwld/vfg-field-matrix/src/components/Matrix.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) { component.functional = true; }
    }

    component._scopeId = scope;

    {
      var hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          var originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    var head = document.head || document.getElementsByTagName('head')[0];
    var styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {});
    var isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) { return } // SSR styles are present.

      var group = isOldIE ? css.media || 'default' : id;
      var style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        var code = css.source;
        var index = style.ids.length;

        style.ids.push(id);

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          var el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) { el.setAttribute('media', css.media); }
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          var textNode = document.createTextNode(code);
          var nodes = style.element.childNodes;
          if (nodes[index]) { style.element.removeChild(nodes[index]); }
          if (nodes.length) { style.element.insertBefore(textNode, nodes[index]); }
          else { style.element.appendChild(textNode); }
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var component = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    __vue_create_injector__,
    undefined
  );

function install (Vue) {
  if (install.installed) { return }
  install.installed = true;
  Vue.component('fieldMatrix', component);
}

var plugin = {
  install: install
};

var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

export default component;
export { install };
